import { ResourceItem } from "../ResourceItem";
import {
  apiField,
  constructFromApiData,
  getApiPostData,
  getDiff,
  itemArrayApiField,
} from "../ResourceItemMetadata";
import { createFullClassResource } from "../../actions";
import { DirectoryPermission, Permission } from "./Permission";

export class Group extends ResourceItem {
  @apiField()
  name: string = "";

  @apiField({
    outputTransform: (users) => users.map((u: any) => ({ id: u.id })),
  })
  users: ResourceItem[] = [];

  @itemArrayApiField(Permission)
  permissions: Permission[] = [];

  @itemArrayApiField(DirectoryPermission)
  directoryPermissions: DirectoryPermission[] = [];

  constructor(data?: any) {
    super(data);

    if (data) constructFromApiData(this, data);
  }

  getPostData() {
    return {
      ...super.getPostData(),
      ...getApiPostData(this),
    };
  }

  getDiff(other: this) {
    return {
      ...getDiff(this, other),
    };
  }
}

export const groupResource = createFullClassResource("iam/group/", Group);
